var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PortalBlock',{attrs:{"portal-block":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }